import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Auth0Provider } from '@auth0/auth0-react';
import config from './auth_config.json';

// A function that routes the user to the right place
// after login
const onRedirectCallback = appState => {
  window.history.replaceState(
    {},
    document.title,
    appState && appState.targetUrl
      ? appState.targetUrl
      : window.location.pathname
  );
};


ReactDOM.render(
  <Auth0Provider
    domain={config.domain}
    clientId={config.clientId}
    authorizationParams={{
      redirect_uri: window.location.origin,
      audience: "https://dev-8o8b478ko47aqil0.us.auth0.com/api/v2/",
      scope: "openid profile email read:current_user update:current_user_metadata"
    }}
    //redirect_uri={window.location.origin}
    onRedirectCallback={onRedirectCallback}
    cacheLocation="localstorage" // optional, keeps session across reloads
    useRefreshTokens={true}     // optional, silently refresh JWT
  >
    <App />
  </Auth0Provider>,
  document.getElementById("root")
);




// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
